<form [formGroup]="subContractorUnconnectedRNDForm">
  <div class="main-box">
    <div class="d-flex p-2 float-end sticky-button">
      <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3">
        <i class="fa-solid fa-download"></i>
        <span class="hidebuttonName"> EXPORT</span>
      </button>
    </div>
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
        <div class="claim-table">
          <div class="table-container">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th class="equal-width-col">{{labelConstants.ContractorName}}</th>
                    <th class="equal-width-col">{{labelConstants.Description}}</th>
                    <th class="equal-width-col"> {{ labelConstants.CostForUKWork }} </th>
                    <th class="equal-width-col"> {{ labelConstants.CostForNonUKWork }} </th>
                    <th *ngFor="let item of projectList" class="equal-width-col">
                      {{ item.projectName }}
                    </th>
                    <th class="equal-width-col">{{ labelConstants.TotalQualifyingCosts65NonUK }}</th>
                    <th class="equal-width-col"> {{ labelConstants.TotalQualifyingcostsat65NonUK }} </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container formArrayName="subContractor">
                    <tr *ngFor="let item of subContractor.controls; let i = index" [formGroupName]="i">
                      <td class="equal-width-col">
                        <span>{{ item.get("subContractorName")?.value }}</span>
                      </td>
                      <td class="equal-width-col">
                        <span>{{
                          item.get("descriptionOfActivities")?.value
                          }}</span>
                      </td>
                      <td class="equal-width-col">
                        <span>{{ item.get("costUK")?.value | customCurrency: env.CurrencyFormat}}</span>
                      </td>
                      <td class="equal-width-col">
                        <span>{{ item.get("costNonUK")?.value | customCurrency: env.CurrencyFormat}}</span>
                      </td>
                      <ng-container formArrayName="projects">
                        <td class="equal-width-col" *ngFor="
                            let itemDetails of getProjectDetails(i).controls;
                            let j = index
                          " [formGroupName]="j">
                          <span>{{ itemDetails.get("rndEligibility")?.value | customPercentage: env.CurrencyFormat
                            }}</span>
                        </td>
                      </ng-container>
                      <td>
                        <span>{{
                          item.get("totalEligibilityAmountForUK")?.value | customCurrency: env.CurrencyFormat
                          }}</span>
                      </td>
                      <td>
                        <span>{{
                          item.get("totalEligibilityAmountForNonUK")?.value | customCurrency: env.CurrencyFormat
                          }}</span>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot *ngIf="subContractor.controls && subContractor.controls.length > 0; else noRecords">
                  <tr>
                    <td  colspan="2"><b>{{labelConstants.ContractorOut}} (£)</b></td>
                    <td class="equal-width-col">
                      <span><b>{{ getCostTotal() | customCurrency: env.CurrencyFormat}}</b></span>
                    </td>
                    <td class="equal-width-col">
                      <span><b>{{ getCostTotal1() | customCurrency: env.CurrencyFormat}}</b></span>
                    </td>
                    <td *ngFor="let item of projectList; let projectIndex = index" class="equal-width-col">
                      <span><b>{{ getTotalProduct(projectIndex) }}</b></span>
                    </td>
                    <td>
                      <span><b>{{ getTotalQualifyingCosts() | customCurrency: env.CurrencyFormat }}</b></span>
                    </td>
                    <td>
                      <span><b>{{ getTotalQualifyingCosts1() | customCurrency: env.CurrencyFormat }}</b></span>
                    </td>
                  </tr>
                </tfoot>
                <ng-template #noRecords>
                  <tfoot>
                    <tr>
                      <td [colSpan]="6+projectList.length" class="text-center">{{commonLabelConstants.NoReacordFound}}
                      </td>
                    </tr>
                  </tfoot>
                </ng-template>
              </table>
            </div>
          </div>
        </div>
    </app-loader>
  </div>
</form>
